import React, { useState } from "react";
import EmpLeadReport from "./EmployeeReport/EmpLeadReport";
import EmpVisitReport from "./EmployeeReport/EmpVisitReport";
import EmpClosedDealReport from "./EmployeeReport/EmpClosedDealReport";
import EmployeeSoldUnits from "./EmployeeReport/EmployeeSoldUnits";
import { SiGoogleads } from "react-icons/si";
import { FaHouseChimney, FaMeta } from "react-icons/fa6";
import { RiCommunityFill } from "react-icons/ri";
import EmpMetaLeadReport from "./EmployeeReport/EmpMetaLeadReport";

const EmployeeReportContent = () => {
  const [selectedComponent, setSelectedComponent] = useState("LeadData");

  return (
    <>
      <div className="flex mt-20">
        <div className="w-[90%] sm:w-full min-h-screen bg-[#F9FAFF] p-2">
          <div className="container">
            {/* Title */}
            <h2 className="text-3xl text-center mt-0 sm:mt-6 font-semibold tracking-wide text-gray-800">
              Report
            </h2>
            <div className="mx-auto h-[3px] w-20 bg-cyan-600 my-4 rounded-full"></div>

            {/* Card Section */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6 mt-4 px-2">
              {/* Leads */}
              <div
                className={`transition-all duration-300 transform hover:scale-105 shadow-md rounded-2xl cursor-pointer border ${
                  selectedComponent === "LeadData"
                    ? "bg-cyan-600 border-cyan-600 text-white shadow-lg shadow-cyan-300/50"
                    : "bg-white border-gray-100 text-gray-800 hover:bg-gray-100"
                }`}
                onClick={() => setSelectedComponent("LeadData")}
              >
                <div className="p-3 sm:p-5 flex flex-col items-center text-center">
                  <div
                    className={`text-2xl sm:text-3xl mb-1 sm:mb-2 ${
                      selectedComponent === "LeadData"
                        ? "text-white"
                        : "text-cyan-600"
                    }`}
                  >
                    <SiGoogleads />
                  </div>
                  <p
                    className="text-xs sm:text-base font-semibold"
                  >
                    Leads
                  </p>
                </div>
              </div>

              {/* Meta Leads */}
              <div
                className={`transition-all duration-300 transform hover:scale-105 shadow-md rounded-2xl cursor-pointer border ${
                  selectedComponent === "metaLeadData"
                    ? "bg-cyan-600 border-cyan-600 text-white shadow-lg shadow-cyan-300/50"
                    : "bg-white border-gray-100 text-gray-800 hover:bg-gray-100"
                }`}
                onClick={() => setSelectedComponent("metaLeadData")}
              >
                <div className="p-3 sm:p-5 flex flex-col items-center text-center">
                  <div
                    className={`text-2xl sm:text-3xl mb-1 sm:mb-2 ${
                      selectedComponent === "metaLeadData"
                        ? "text-white"
                        : "text-cyan-600"
                    }`}
                  >
                    <FaMeta />
                  </div>
                  <p
                    className="text-xs sm:text-base font-semibold"
                  >
                    Meta Leads
                  </p>
                </div>
              </div>

              {/* Site Visit */}
              <div
                className={`transition-all duration-300 transform hover:scale-105 shadow-md rounded-2xl cursor-pointer border ${
                  selectedComponent === "VisitData"
                    ? "bg-cyan-600 border-cyan-600 text-white shadow-lg shadow-cyan-300/50"
                    : "bg-white border-gray-100 text-gray-800 hover:bg-gray-100"
                }`}
                onClick={() => setSelectedComponent("VisitData")}
              >
                <div className="p-3 sm:p-5 flex flex-col items-center text-center">
                  <div
                    className={`text-2xl sm:text-3xl mb-1 sm:mb-2 ${
                      selectedComponent === "VisitData"
                        ? "text-white"
                        : "text-cyan-600"
                    }`}
                  >
                    <FaHouseChimney />
                  </div>
                  <h5
                    className="text-xs sm:text-base font-semibold"
                  >
                    Site Visit
                  </h5>
                </div>
              </div>

              {/* Sold Units */}
              <div
                className={`transition-all duration-300 transform hover:scale-105 shadow-md rounded-2xl cursor-pointer border ${
                  selectedComponent === "SoldUnits"
                    ? "bg-cyan-600 border-cyan-600 text-white shadow-lg shadow-cyan-300/50"
                    : "bg-white border-gray-100 text-gray-800 hover:bg-gray-100"
                }`}
                onClick={() => setSelectedComponent("SoldUnits")}
              >
                <div className="p-3 sm:p-5 flex flex-col items-center text-center">
                  <div
                    className={`text-2xl sm:text-3xl mb-1 sm:mb-2 ${
                      selectedComponent === "SoldUnits"
                        ? "text-white"
                        : "text-cyan-600"
                    }`}
                  >
                    <RiCommunityFill />
                  </div>
                  <h5
                    className="text-xs sm:text-base font-semibold"
                  >
                    Sold Units
                  </h5>
                </div>
              </div>
            </div>

            {/* Render Selected Component */}
            <div className="w-full h-[calc(100vh-12rem)] overflow-y-auto mt-6 bg-white shadow-inner rounded-xl p-2 sm:p-4">
              {selectedComponent === "LeadData" && <EmpLeadReport />}
              {selectedComponent === "metaLeadData" && <EmpMetaLeadReport />}
              {selectedComponent === "VisitData" && <EmpVisitReport />}
              {selectedComponent === "ClosedData" && <EmpClosedDealReport />}
              {selectedComponent === "SoldUnits" && <EmployeeSoldUnits />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployeeReportContent;
